<template>
  <div class="bbp-reminder-panel-header">
    <div class="bbp-reminder-panel-header__wrap">
      <div class="bbp-reminder-panel-header__title">
        Reminders
      </div>
      <div
        v-if="counterNotification"
        class="bbp-reminder-panel-header__counter"
      >
        {{counterNotification}}
      </div>
      <transition name="bbp-fade">
        <div
          v-if="counterNotification ? !isShowForm: false"
          class="bbp-reminder-panel-header__add"
          v-html="plusIcon()"
          @click="onPlus"
        />
      </transition>
      <i
        class="bbp-icon-cross bbp-reminder-panel-header__close"
        @click="onClose"
      />
    </div>
    <div class="bbp-reminder-panel-header__desc">
      {{row.name}}
    </div>
  </div>
</template>

<script>
import { PLUS_ICON } from '@/constants/icons'

export default {
  name: 'BBPReminderPanelHeader',
  props: {
    isShowForm: {
      type: Boolean,
      default: false
    },
    counterNotification: {
      type: Number,
      default: 0
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    plusIcon: PLUS_ICON
  }),
  methods: {
    onClose () {
      this.$store.dispatch('setShowPanel', false)
    },
    onPlus () {
      this.$emit('update:isShowForm', true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";

  .bbp-reminder-panel-header {
    min-height: 87px;
    padding: 28px 22px 20px 22px;
    position: relative;
    border-bottom: 1px solid $color-wild-sand;

    &__wrap {
      display: flex;
      align-items: center;
      margin: 0 0 6px 0;
    }

    &__title {
      font-size: 16px;
      line-height: 19px;
      font-weight: 600;
      margin: 0 8px 0 0;
    }

    &__desc {
      width: 90%;
      font-size: 12px;
      line-height: 14px;
      font-weight: 400;
      color: $color-gray;
    }

    &__counter {
      margin: 0 10px 0 0;
      padding: 3px 6px 3px 6px;
      border-radius: 3px;
      font-size: 11px;
      line-height: 13px;
      font-weight: 500;
      background: rgba($color-denim, 0.11);
      color: $color-denim;
    }

    &__add {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: $color-wild-sand;
      transition: 0.15s;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }

    &__close {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 22px;
      top: 22px;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      background: rgba($color-denim, 0.11);
      cursor: pointer;
      color: $color-denim;
      font-size: 18px;
      transition: 0.15s;

      &:hover {
        opacity: 0.8;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelHeader/BBPReminderPanelHeader.vue